import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { TimeSlot } from '../model/timeSlot';
import { Log } from '../util/log';

@Component({
  selector: 'app-time-slot-dialog',
  templateUrl: './time-slot-dialog.component.html',
  styleUrls: ['./time-slot-dialog.component.css']
})
export class TimeSlotDialogComponent implements OnInit {

  fromHour: number = 0;
  fromMinutes: number = 0;
  toHour: number = 0;
  toMinutes: number = 0;
  error = false;

  toMidnight: boolean = false;

  fiveMinPrecision: boolean = false;

  tenMinPrecision: boolean = false;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<TimeSlotDialogComponent>
  ) {

    if (data.minPrecision == 5) {
      this.fiveMinPrecision = true;
    } else if (data.minPrecision == 10) {
      this.tenMinPrecision = true;
    } else {
      // keep both false
    }
  }

  ngOnInit() {

  }

  selectFromHourChanged(event: any) {
    this.error = false;
    this.fromHour = Number(event.target.value);
  }

  selectFromMinutesChanged(event: any) {
    this.error = false;
    this.fromMinutes = Number(event.target.value);
  }

  selectToHourChanged(event: any) {
    this.error = false;
    this.toHour = Number(event.target.value);
    if (this.toHour == 24) {
      this.toMidnight = true;
    } else {
      this.toMidnight = false;
    }
  }

  selectToMinutesChanged(event: any) {
    this.error = false;
    this.toMinutes = Number(event.target.value);
  }

  closeTimeSlotDialog() {

    this.dialogRef.close();
  }

  addTimeSlot() {

    if (this.fromHour > this.toHour) {
      this.error = true;
    }
    else if (this.fromHour == this.toHour && this.fromMinutes >= this.toMinutes) {
      this.error = true;
    }
    else {
      this.error = false;
      this.dialogRef.close(new TimeSlot(this.fromHour, this.fromMinutes, this.toHour, this.toMinutes));
    }
  }

}
